import { createAsyncAction, errorResult, Store, successResult } from "pullstate";
import React, { useEffect } from "react";
import { InlineLoading } from "./Loading";

const createFetchData = DataUrlStore => createAsyncAction(async ({ data_url, count, page, tag, usePublicationDate }) => {
    if (data_url === null) {
        // do nothing if url is null!
        return successResult(null);
    }
    let tagParam = "";
    if (tag) {
        tagParam = `&tag=${encodeURIComponent(tag)}`;
    }
    let usePublicationDateParam = "";
    if (usePublicationDate) {
        usePublicationDateParam = "&use_publication_date=true"
    }
    const response = await fetch(`${data_url}&count=${count}&page=${page}${tagParam}${usePublicationDateParam}`)
    if (response.ok) {
        return successResult(await response.json());
    } else {
        if (response.status == 404) {
            return errorResult([], `An error occurred, resource not found - ${response.status}`);
        } else if (response.status == 403) {
            return errorResult([], `An error occurred, access denied - ${response.status}`);
        } else {
            return errorResult([], `An error occurred, please try again later - ${response.status}`);
        }
    }
}, {
    postActionHook: function ({ result }) {
        if (!result.error && result.payload !== null) {
            DataUrlStore.update(function (state) {
                state.total = result.payload.post_count;
                state.next_data_url = result.payload.data_url;
            })
        };
    }
});




// changing the state of the store will trigger a page reload
// 
// At page initialization, the data_url is null, the async action will do nothing 
// and an effect will actually set the data_url in this store, triggering the fetch.
//
// this store also hold pagination values.
export const DataUrlStoreContext = React.createContext();

/**
 * HOC used to load data
 */
export function loadData(Renderer) {
    // Instanciate a DataUrlStore for each instance of the 
    // embed in the page, and pass it with react context.
    const Component = ({ data_url, count = 30, ...props }) => {
        let realCount;
        if (props.maxPosts) {
            realCount = props.maxPosts;
        } else {
            realCount = count;
        }
        const DataUrlStore = new Store({
            data_url,
            count: realCount,
            page: 0,
            total: null,
            next_data_url: null,
            tag: props.filterByTag,
            usePublicationDate: props.usePublicationDate,
        });
        const fetchData = createFetchData(DataUrlStore);

        const Loader = (props) => {
            const store_data_url = DataUrlStore.useState(state => state.data_url);
            const store_count = DataUrlStore.useState(state => state.count);
            const store_page = DataUrlStore.useState(state => state.page);
            const store_tag = DataUrlStore.useState(state => state.tag);
            const store_usePublicationDate = DataUrlStore.useState(state => state.usePublicationDate);
            const [finished, result] = fetchData.useBeckon({
                data_url: store_data_url,
                count: store_count,
                page: store_page,
                tag: store_tag,
                usePublicationDate: store_usePublicationDate,
            });

            if (!finished || result === null) {
                return <DataUrlStoreContext.Provider value={DataUrlStore}>
                    <InlineLoading />
                </DataUrlStoreContext.Provider>;
            }
            if (result.error) {
                return <DataUrlStoreContext.Provider value={DataUrlStore}>
                    <div className={"scp-text-red-600"}>{result.message}</div>
                </DataUrlStoreContext.Provider>;
            }
            return <DataUrlStoreContext.Provider value={DataUrlStore}>
                <Renderer data={result.payload} {...props} />
            </DataUrlStoreContext.Provider>;
        };
        return <Loader {...props} />
    }


    return Component;
}
